<template>
<div>
    <v-card>
      <v-toolbar dense class="toolbar" height="35px" color="grey lighten-3">     
        <img class="img-icons" src="@/assets/passenger_details_icon.png" id="icon" alt="User Icon" />          
        <span >Passenger Details </span>
        <v-spacer></v-spacer>
         <div class="md-toolbar-section-end">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn small v-on="on">
                    <img class="img-icons" src="@/assets/paste_icon.png"/>  PASTE INFO
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="menuAction(item)" v-for="(item, index) in menuItems" :key="index">
                    <v-list-item-content style="justify-content: center;">
                      <img width="80" height="25" style="object-fit: contain;" :src="require(`@/assets/${item}_logo.png`)" />
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu> 
              <v-btn small style="margin-left:10px" @click="addPassengers()">
                    <img class="img-icons" src="@/assets/add_passenger_icon.png"/>  ADD PASSENGER
              </v-btn>
        </div>
      </v-toolbar>
      
       <ag-grid-vue style="width: 100%;"
                 class="ag-theme-balham"
                 :columnDefs="columnDefs"
                 :enableFillHandle="true"
                 :defaultColDef="defaultColDef"
                 :frameworkComponents="frameworkComponents"
                 :context="context"
                 domLayout="autoHeight"
                 @cell-value-changed="gridDataChanged"
                 :rowData="passengersData">
                </ag-grid-vue>
    
    </v-card>
    
</div>
</template>

<script>

 var valueFormatter = function (param) {
    let data = param.data;
    console.log("gehege")
    let val=data[param.colDef.field]
    return parseFloat(val).toFixed(2)
  };


  import { validationMixin } from 'vuelidate'
  import {AgGridVue} from "ag-grid-vue";
  import DeleteCell from "./DeleteCell.js";
  import {mapActions, mapState} from 'vuex'
  import Util from "../../../util/util.js"




  export default {
    name: 'passenger-detail-panel',
    computed: {
        ...mapState('invoice', ['selectedInvoice','newInvoiceData']),
    },
    watch: {
        selectedInvoice(newValue, oldValue) {
            console.log("hello");
            console.log(oldValue)
            console.log(newValue)
            if (newValue.passengers)
              this.passengersData = JSON.parse(JSON.stringify(newValue.passengers))            
            else 
              this.passengersData=[]
        },
        newInvoiceData(newValue, oldValue) {
            console.log("hello");
            console.log(oldValue)
            console.log(newValue)
            if (newValue)
              this.passengersData = JSON.parse(JSON.stringify(newValue.passengers))
        }
    },  
    mixins: [validationMixin],  
    components: {
            AgGridVue,            
        },
    beforeMount() {
        this.context = { componentParent: this };
    },
    data: () => ({
      invoice: {
        id: null,
        date: null,        
      },
      passengersData:[],
      context: null,
      columnDefs:[
          { headerName: 'Passenger Name', field: 'name'},
          { headerName: 'D.O.B', field: 'dateOfBirth' },
          { headerName: 'Passport', field: 'passport' },
          { headerName: 'Ticket No', field: 'ticketNumber'} ,
          { headerName: 'Cost', field: 'netPrice', valueFormatter: valueFormatter },
          { headerName: 'Taxes', field: 'taxes', valueFormatter: valueFormatter },
          { headerName: 'Sale Price', field: 'gross', valueFormatter: valueFormatter },
          { headerName: 'Void', field: 'void' },
          {
        headerName: "Action",
        field: "value",
        cellRenderer: "deleteCell",
        editable: false,
        colId: "deleteCell",
        width: 150
      },
        ], 
      frameworkComponents:{deleteCell:DeleteCell},      
      
        menuItems:["sabre", "btres", "emirates", "tkconnect", "gds"],
        defaultColDef: {
          flex: 1,
        editable: true
      },
      suppliers: [],
      gdsValues: []
    }),
    created () {
      // let self = this
    },
    methods: {
        ...mapActions('invoice', ['updateSabreInvoiceData','updateBtresInvoiceData','updateTkConnectInvoiceData','updateEmiratesInvoiceData','updatePassengersData']),
        gdsPasteAction(content)  {
          console.log(content);
        },
        gridDataChanged()  {
          let clonePassengersData=JSON.parse(JSON.stringify(this.passengersData))
          this.updatePassengersData(clonePassengersData)
        },
        addPassengers()  {
            this.passengersData.push({name:"",dateOfBirth:"",passport:"",ticketNumber:"",netPrice:"", taxes:"0.00", gross:"", void:""});
        },
        sabrePasteAction(content)  {
          let sabreData = Util.parseSabreText(content)          
          this.updateSabreInvoiceData(sabreData)          
       },
       btresPasteAction(content) {
          let btresData = Util.parseBtresText(content);
          this.updateBtresInvoiceData(btresData);
       },
       tkconnectPasteAction(content) {
          let tkconnectData = Util.parseTkConnectText(content);
          this.updateTkConnectInvoiceData(tkconnectData);
       },
       emiratesPasteAction(content) {
          let emiratesData = Util.parseEmiratesText(content);
          this.updateEmiratesInvoiceData(emiratesData);
       },
      async menuAction(title) {
          console.log(this)
        let pastedText = await navigator.clipboard.readText();

        if (title=="sabre") {          
            this.sabrePasteAction(pastedText)
        }
        else if (title=="btres") {
            this.btresPasteAction(pastedText)
        }
        else if (title=="tkconnect") {
            this.tkconnectPasteAction(pastedText)
        }
        else if (title=="emirates") {
            this.emiratesPasteAction(pastedText)
        }
        else if (title=="gds") {           
            this.gdsPasteAction(pastedText)   
        }
        else {
          console.log("action not supported")
        }
      },
       methodFromParent(rowIndex) {
          this.passengersData.splice(rowIndex,1);
          this.gridDataChanged()
      }
    }
  }
</script>

<style lang="scss">
  .thead-container {
    height: auto !important;
    padding: 0px 0 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .td {
    height: 28px !important;
  }
  
</style>

<style scoped>
  .v-btn {
    margin: 0px 0;
    height:auto;
  }
  .img-icons {
    height: 24px;
  }
  .menu-logo {
    height: 20px;
  }
  .table-remove-icon {
    min-width: auto
  }
  .v-container {
    padding-top: 0px;
    padding-bottom: 0px !important;
  }
</style>